/*
 * @Descripttion:
 * @version:
 * @Author: xKai
 * @Date: 2019-11-06 17:16:37
 * @LastEditors: your name
 * @LastEditTime: 2022-01-16 15:39:44
 */
import util from "@util/js";

// 明亮
const simple = {
  "--color-white": "#ffffff",
  "--color-black": "#000000",
  "--color-primary": "#294a7c",
  "--color-success": "#49e0fb",
  "--color-warning": "#fa930e",
  "--color-danger": "#f55252",
  "--color-error": "#f55252",
  "--color-info": "#dddddd",
  "--bg-color": "#f5f7fa",
  "--svg-monochrome-grey": "#dcdde0",
  "--text-color-disabled-base": "#bbb",
  "--text-color-primary": "#333333",
  "--text-color-regular": "#606266",
  "--text-color-secondary": "#909399",
  "--text-color-placeholder": "#c0c4cc",
  "--border-color-base": "#dcdfe6",
  "--border-color-extra-light": "#f2f6fc",
  "--box-shadow-base": "0 2px 4px rgba(0, 0, 0, 0.12),0 0 6px rgba(0, 0, 0, 0.04)",
  "--box-shadow-light": "0 2px 12px 0 rgba(0, 0, 0, 0.1)"
};

// 护眼
const eyehelp = {
  "--color-white": "#CEEDD1",
  "--color-black": "#000000",
  "--color-primary": "#66C86E",
  "--color-success": "#00dd98",
  "--color-warning": "#FA930E",
  "--color-danger": "#F55252",
  "--color-error": "#F55252",
  "--color-info": "#999999",
  "--bg-color": "#f5f7fa",
  "--border-width-base": "1px",
  "--border-style-base": "solid",
  "--svg-monochrome-grey": "#dcdde0",
  "--text-color-disabled-base": "#bbb",
  "--text-color-primary": "#66C86E",
  "--text-color-regular": "#666666",
  "--text-color-secondary": "#909399",
  "--text-color-placeholder": "#CCCCCC", // select禁选
  "--border-color-base": "#dcdfe6",
  "--border-color-extra-light": "#f2f6fc",
  "--box-shadow-base": "0 2px 4px rgba(0, 0, 0, 0.12),0 0 6px rgba(0, 0, 0, 0.04)",
  "--box-shadow-light": "0 2px 12px 0 rgba(0, 0, 0, 0.1)",
  "--el-card-padding": "padding:20px 20px 10px"
};

// 复古
const retro = {
  "--color-white": "#F7F5EA",
  "--color-black": "#000000",
  "--color-primary": "#CDC27D",
  "--color-success": "#27CBA6",
  "--color-warning": "#FA930E",
  "--color-danger": "#F55252",
  "--color-error": "#F55252",
  "--color-info": "#999999",
  "--bg-color": "#f5f7fa",
  "--svg-monochrome-grey": "#dcdde0",
  "--text-color-disabled-base": "#bbb",
  "--text-color-primary": "#CDC27D",
  "--text-color-regular": "#666666",
  "--text-color-secondary": "#909399",
  "--text-color-placeholder": "#CCCCCC", // select禁选
  "--border-color-base": "#dcdfe6",
  "--border-color-extra-light": "#f2f6fc",
  "--box-shadow-base": "0 2px 4px rgba(0, 0, 0, 0.12),0 0 6px rgba(0, 0, 0, 0.04)",
  "--box-shadow-light": "0 2px 12px 0 rgba(0, 0, 0, 0.1)"
};

// 海天
const haitian = {
  "--color-white": "#e9edf6",
  "--color-black": "#e9edf6",
  "--color-primary": "#4a69b7",
  "--color-success": "#27CBA6",
  "--color-warning": "#FA930E",
  "--color-danger": "#F55252",
  "--color-error": "#F55252",
  "--color-info": "#999999",
  "--bg-color": "#f5f7fa",
  "--svg-monochrome-grey": "#dcdde0",
  "--text-color-disabled-base": "#bbb",
  "--text-color-primary": "#4a69b7",
  "--text-color-regular": "#101410",
  "--text-color-secondary": "#909399",
  "--text-color-placeholder": "#CCCCCC", // select禁选
  "--border-color-base": "#dcdfe6",
  "--border-color-extra-light": "#f2f6fc",
  "--box-shadow-base": "0 2px 4px rgba(0, 0, 0, 0.12),0 0 6px rgba(0, 0, 0, 0.04)",
  "--box-shadow-light": "0 2px 12px 0 rgba(0, 0, 0, 0.1)"
};

// 暗黑
const dark = {
  "--color-white": "#25252a",
  "--color-black": "#ffffff",
  "--color-primary": "#388FF3",
  "--color-success": "#27CBA6",
  "--color-warning": "#FA930E",
  "--color-danger": "#F55252",
  "--color-error": "#F55252",
  "--color-info": "#999999",
  "--bg-color": "#19191c",
  "--svg-monochrome-grey": "#dcdde0",
  "--text-color-disabled-base": "#bbb",
  "--text-color-primary": "#388FF3",
  "--text-color-regular": "#ddd",
  "--text-color-secondary": "#909399",
  "--text-color-placeholder": "#CCCCCC", // select禁选
  "--border-color-base": "#353745",
  "--border-color-extra-light": "#f2f6fc",
  "--box-shadow-base": "0 2px 4px rgba(0, 0, 0, 0.12),0 0 6px rgba(0, 0, 0, 0.04)",
  "--box-shadow-light": "0 2px 12px 0 rgba(0, 0, 0, 0.1)"
};

// 深邃
const deep = {
  "--color-white": "#1C283B",
  "--color-black": "#e9edf6",
  "--color-primary": "#50a1ff",
  "--color-success": "#27CBA6",
  "--color-warning": "#FA930E",
  "--color-danger": "#F55252",
  "--color-error": "#F55252",
  "--color-info": "#999999",
  "--bg-color": "#f5f7fa",
  "--svg-monochrome-grey": "#dcdde0",
  "--text-color-disabled-base": "#bbb",
  "--text-color-primary": "#50a1ff",
  "--text-color-regular": "#a0b4c8",
  "--text-color-secondary": "#909399",
  "--text-color-placeholder": "#CCCCCC", // select禁选
  "--border-color-base": "#dcdfe6",
  "--border-color-extra-light": "#f2f6fc",
  "--box-shadow-base": "0 2px 4px rgba(0, 0, 0, 0.12),0 0 6px rgba(0, 0, 0, 0.04)",
  "--box-shadow-light": "0 2px 12px 0 rgba(0, 0, 0, 0.1)"
};
// 新年
const newYear = {
  "--color-white": "#A30A0A",
  "--color-black": "#000000",
  "--color-primary": "#ffe82a",
  "--color-success": "#27CBA6",
  "--color-warning": "#FA930E",
  "--color-danger": "#F55252",
  "--color-error": "#f56c6c",
  "--color-info": "#999999",
  "--bg-color": "#f5f7fa",
  "--svg-monochrome-grey": "#dcdde0",
  "--text-color-disabled-base": "#bbb",
  "--text-color-primary": "#303133",
  "--text-color-regular": "#606266",
  "--text-color-secondary": "#909399",
  "--text-color-placeholder": "#c0c4cc",
  "--border-color-base": "#dcdfe6",
  "--border-color-extra-light": "#f2f6fc",
  "--box-shadow-base": "0 2px 4px rgba(0, 0, 0, 0.12),0 0 6px rgba(0, 0, 0, 0.04)",
  "--box-shadow-light": "0 2px 12px 0 rgba(0, 0, 0, 0.1)"
};

// // 通用配置
// const common = {
//   "--card-padding": "10px"
// };
// light或lighter为渐变色
const setPrimaryLightNew = data => {
  // Object.assign(data, common);
  const white = data["--color-white"];
  const attribute = [
    "--color-success",
    "--color-warning",
    "--color-danger",
    "--color-error",
    "--color-info",
    "--border-color"
  ];
  const types = ["light", "lighter"];
  attribute.forEach(type => {
    let attr = type;
    if (type === "--border-color") {
      attr = type + "-base";
    }
    const mainColor = data[attr];
    if (mainColor) {
      types.forEach((item, index) => {
        const color = util.colourBlend(mainColor, white, (index + 2) / 5);
        data[`${type}-${item}`] = color;
      });
    }
  });
  const primary = data["--color-primary"];
  for (let i = 1; i < 10; i++) {
    const color = util.colourBlend(primary, white, i / 10);
    data["--color-primary-light-" + i] = color;
  }
  data["--border-color-extra-light"] = data["--color-primary-light-2"];
  const obj = {};
  for (const item of Object.keys(data)) {
    const key = item.replace("--", "--el-");
    obj[key] = data[item];
  }
  return obj;
};
export const themeList = {
  // 语法规定前面要加--
  simple: setPrimaryLightNew(simple),
  eyehelp: setPrimaryLightNew(eyehelp),
  retro: setPrimaryLightNew(retro),
  dark: setPrimaryLightNew(dark),
  haitian: setPrimaryLightNew(haitian),
  deep: setPrimaryLightNew(deep),
  newYear: setPrimaryLightNew(newYear)
};